// extracted by mini-css-extract-plugin
export default {"root":"Link_root__cN3c3","icon":"Link_icon__j6LZm","disabled":"Link_disabled__2RWIg"};